/**
 * если на странице выполняется подгрузка отзывов через ajax,
 * следует добавить контейнеру отзывов дата атрибут 'data-review-cards-container'
 */

import initI18n from 'www/utils/executors/initI18n'
import Hint from 'www/modules/Hint'
import PopupContent from 'www/modules/PopupContent'
import { scrollToReviewOrReviewsContainer } from 'www/modules/ReviewsPage/functions'
import { getSliderRenderFn } from 'www/library.blocks/common/b-popup-content/utils'
import { addListenerClickAuthorReview, addListenerClickReviewMore } from 'www/doctors.blocks/common/b-review-card/functions'

const reviewSelectors = {
  CLASS_HINT: 'b-review-card__hint',
  SELECTOR_BTN_TOOLTIP: '.b-review-card__tooltip',
}

addListenerClickAuthorReview()

new PopupContent({
  id: 'embed-images',
  selector: '.b-review-card__embed-img-wrapper',
  modifier: 'b-review-card',
  pagination: 'dynamic',
  createHead: false,
  createDescription: false,
  beforeShow: getSliderRenderFn('.b-review-card__embed-images-container'),
  modalOptions: {
    useHash: false,
  },
})

async function initHint() {
  const { i18next, userLanguage } = await initI18n({ bundle: 'doctors.blocks/common/b-review-card' })

  new Hint({
    modifier: reviewSelectors.CLASS_HINT,
    isMobile: false,
    text: i18next.t('Клиника связалась с автором отзыва и исправила ситуацию. Он подтвердил, что описанную проблему решили. Оценка больше не влияет на рейтинг.', { ns: userLanguage }),
    target: reviewSelectors.SELECTOR_BTN_TOOLTIP,
    maxWidth: 'large',
    tippyOptions: {
      placement: 'bottom-start',
      trigger: 'mouseenter',
      zIndex: 5,
      offset: [-56, 15],
    },
  })
}

initHint()

scrollToReviewOrReviewsContainer()

document.addEventListener('click', addListenerClickReviewMore)
document.addEventListener('click', event => {
  try {
    const buttonShowAll = event.target.closest('.b-review-card-rates-show-more')

    if (buttonShowAll) {
      const wrapper = document.querySelector('.b-review-card-wrapper')
      const hiddenBlock = wrapper.querySelector('.b-review-card-wrapper-hidden')
      const reviewBtn = document.querySelector('[data-review-btn]')

      if (hiddenBlock) {
        buttonShowAll.classList.add('d-none')
        hiddenBlock.classList.remove('d-none')
      }

      if (reviewBtn) {
        reviewBtn.classList.remove('d-none')
      }
    }
  } catch {} // eslint-disable-line
})
